import { render, staticRenderFns } from "./TranslateTemplateImageModal.vue?vue&type=template&id=16c4d81b&scoped=true"
import script from "./TranslateTemplateImageModal.vue?vue&type=script&lang=js"
export * from "./TranslateTemplateImageModal.vue?vue&type=script&lang=js"
import style0 from "./TranslateTemplateImageModal.vue?vue&type=style&index=0&id=16c4d81b&scoped=true&lang=scss"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c4d81b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c4d81b')) {
      api.createRecord('16c4d81b', component.options)
    } else {
      api.reload('16c4d81b', component.options)
    }
    module.hot.accept("./TranslateTemplateImageModal.vue?vue&type=template&id=16c4d81b&scoped=true", function () {
      api.rerender('16c4d81b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/TranslateTemplateImageModal.vue"
export default component.exports